import React, { useEffect, useMemo, useState } from "react";
import ActionableTable from "../actionables/ActionableTable";
import useAssignedOrders from "modules/customerlist/store";
import ShowCustomer from "../actionables/ShowCustomer";
import { isArray } from "lodash";
import EmptyBoxDataIcon from "assets/svgs/empty_box_icon";

function ActionableCustomerList({ actionableTabs, actionableData, ...props }) {
  const [pageNumber] = useState(1);
  const [docData, setDocData] = useState();
  const { fetchAssignedOrderData } = useAssignedOrders();
  const [showCustomerInFull] = useState(false);
  const [customerData, setCustomerData] = useState(actionableData);
  const [activeCaseId, setActiveCaseId] = useState();

  useEffect(() => {
    setCustomerData(actionableData);
  }, [actionableData]);

  useEffect(() => {
    fetchAssignedOrderData(pageNumber);
  }, [pageNumber]);
  const data = useMemo(() => {
    return customerData?.map((customer) => {
      let orderCount = customer?.order?.count;
      let repeatOrderTag = orderCount === 1 ? "NEW" : `RO ${orderCount}`;
      let attempt = customer?.attempt_count;
      let slotBookingMedicalAttempt = customer.unanswered_count;
      let attemptData =
        attempt == 1
          ? "1st Attempt"
          : attempt == 2
          ? "2nd Attempt"
          : "3rd Attempt";
      return {
        _id: customer?._id,
        tag: customer.tag,
        alternate_email: "",
        order: customer?.order,
        status: customer?.status,
        alternate_phone_number: "",
        case_id: customer?.case_id,
        count: customer?.order?.count,
        bulk: customer?.is_bulk_order,
        updated_at: customer?.updatedAt,
        created_at: customer?.createdAt,
        order_type: customer?.order_type,
        single: customer?.is_single_order,
        email: customer?.case?.user?.email,
        tracking_id: customer?.tracking_id,
        order_count: customer?.order?.count,
        gender: customer?.case?.user?.gender ?? "",
        tracking_url: customer?.tracking_url,
        order_date: customer?.due_date,
        reminder_date: customer?.reminder_date,
        order_name: customer?.order_meta?.name,
        last_name: customer?.case?.user?.last_name,
        order_id: customer?.order?.order_display_id,
        reschedule_count: customer?.reschedule_count,
        first_name: customer?.case?.user?.first_name,
        phone_number: customer?.case?.user?.phone_number,
        booking_reference_id: customer?.booking_reference_id,
        isSlotBooked: customer?.is_slot_booked,
        unanswered_count: customer?.unanswered_count,
      tags: [customer?.tag, attemptData, customer?.status, repeatOrderTag, `Unanswered Count: ${slotBookingMedicalAttempt}`],
      };
    });
  }, [ customerData ]);

  return (
    isArray(data) && (
      <div style={{ height: "75vh" }}>
        <div className="d-flex h-100">
          <div
            style={{
              opacity: props.showCustomerInFull ? 0 : 1,
              width: props.showCustomerInFull ? "0" : "33%",
              transition: "width 0.3s ease, opacity 0.3s ease",
              overflow: "hidden",
            }}
          >
            {
              <ActionableTable
                details={"details"}
                setState={setDocData}
                setDocData={setDocData}
                fieldOneName={"Doctor Name"}
                actionableTabs={actionableTabs}
                setActiveCaseId={setActiveCaseId}
                data={data?.length == 0 ? [] : data}
                actionableLoading={props.actionableLoading}
                filterBy={props.filterBy}
                setFilterBy={props.setFilterBy}
              />
            }
          </div>

          <div
            style={{
              width: showCustomerInFull ? "100%" : "77%",
              transition: "width 0.3s ease",
              overflow: "auto",
            }}
            className="flex-fill mx-3 mt-n3 p-0 scrollable-section"
          >
            {data?.length ? (
              <div>
                <ShowCustomer
                  caseId={activeCaseId || data[0].case_id}
                  actionableTabs={actionableTabs}
                  showCustomerInFull={props.showCustomerInFull}
                  setShowCustomerInFull={props.setShowCustomerInFull}
                />
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-center">
                <EmptyBoxDataIcon />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  );
}

export default ActionableCustomerList;
